// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/fonts/Jost-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../public/fonts/Jost-Regular.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input[type=text]::placeholder,
select::placeholder, input[type=text],
select {
  font-family: "Jost", sans-serif;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.01em;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
  text-decoration: none;
}

@font-face {
  font-family: "Jost";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
  font-weight: 400;
}
body {
  font-family: "Jost", sans-serif;
  color: #0f0f0f;
  margin: 0;
}
body * {
  box-sizing: border-box;
}

.btn-primary {
  color: #ffffff;
  text-align: center;
  position: relative;
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0f0f0f;
  padding: 8px 16px;
  border: 0;
  outline: 0;
  transition: color 0.25s, background-color 0.35s, opacity 0.35s;
  cursor: pointer;
  z-index: 0;
  text-transform: uppercase;
}
.btn-primary:disabled, .btn-primary[disabled] {
  opacity: 0.7;
  pointer-events: none;
}
.btn-primary:focus-visible {
  background-color: #545454;
}
@media (hover: hover) {
  .btn-primary:hover {
    background-color: #545454;
  }
}
.btn-primary::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: block;
  background-color: rgba(255, 255, 255, 0.6);
  opacity: 0;
  transition: opacity 0.25s;
  z-index: 1;
}
.btn-primary::after {
  content: "";
  position: absolute;
  top: calc(50% - 10px);
  left: calc(50% - 10px);
  width: 16px;
  height: 16px;
  display: block;
  border-radius: 50%;
  border: 4px solid #0f0f0f;
  border-top: 4px solid #545454;
  opacity: 0;
  transition: opacity 0.25s;
  animation: spin 2s linear infinite;
  z-index: 2;
}
.btn-primary.loading {
  color: transparent;
  pointer-events: none;
}
.btn-primary.loading::before {
  opacity: 1;
}
.btn-primary.loading::after {
  opacity: 1;
}

.btn-outline {
  color: #0f0f0f;
  text-align: center;
  position: relative;
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  padding: 8px 16px;
  border: 1px solid #0f0f0f;
  outline: 1px solid transparent;
  outline-offset: -2px;
  transition: color 0.25s, outline-color 0.35s, opacity 0.35s;
  cursor: pointer;
  z-index: 0;
}
.btn-outline:disabled, .btn-outline[disabled] {
  opacity: 0.7;
  pointer-events: none;
}
.btn-outline:focus-visible {
  outline-color: #0f0f0f;
}
@media (hover: hover) {
  .btn-outline:hover {
    outline-color: #0f0f0f;
  }
}
.btn-outline::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: block;
  opacity: 0;
  transition: opacity 0.25s;
  z-index: 1;
  pointer-events: none;
}
.btn-outline::after {
  content: "";
  position: absolute;
  top: calc(50% - 10px);
  left: calc(50% - 10px);
  width: 16px;
  height: 16px;
  display: block;
  border-radius: 50%;
  border: 4px solid #0f0f0f;
  border-top: 4px solid #545454;
  opacity: 0;
  transition: opacity 0.25s;
  animation: spin 2s linear infinite;
  z-index: 2;
  pointer-events: none;
}
.btn-outline.loading {
  color: transparent;
  pointer-events: none;
}
.btn-outline.loading::before {
  opacity: 1;
}
.btn-outline.loading::after {
  opacity: 1;
}

input[type=text],
select {
  padding: 2px 0 8px;
  border: 0;
  border-bottom: 1px solid #0f0f0f;
  border-radius: 0;
  outline: 0;
  transition: border-color 0.35s;
}
input[type=text]::placeholder,
select::placeholder {
  opacity: 0.5;
}
input[type=text].error,
select.error {
  border-color: #ed4848;
}`, "",{"version":3,"sources":["webpack://./src/common.scss","webpack://./src/index.scss","webpack://./src/clear.scss"],"names":[],"mappings":"AAqBA;;;EACE,+BApBe;EAqBf,eAAA;EACA,iBAAA;EACA,sBAAA;AClBF;;ADmCA;EACE;IACE,uBAAA;EChCF;EDkCA;IACE,yBAAA;EChCF;AACF;AChBA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAiFE,SAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,wBAAA;EACA,qBAAA;ADkBF;;AAtGA;EACE,mBAAA;EACA,oHACE;EAEF,gBAAA;AAuGF;AApGA;EACE,+BDVe;ECWf,cDRc;ECSd,SAAA;AAsGF;AApGE;EACE,sBAAA;AAsGJ;;AAlGA;EACE,cDhBgB;ECiBhB,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBDzBc;EC0Bd,iBAAA;EACA,SAAA;EACA,UAAA;EACA,8DACE;EAGF,eAAA;EACA,UAAA;EACA,yBAAA;AAkGF;AAhGE;EAEE,YAAA;EACA,oBAAA;AAiGJ;AA9FE;EACE,yBDvCQ;ACuIZ;AA7FE;EACE;IACE,yBD5CM;EC2IV;AACF;AA5FE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,0CAAA;EACA,UAAA;EACA,yBAAA;EACA,UAAA;AA8FJ;AA3FE;EACE,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,6BAAA;EACA,UAAA;EACA,yBAAA;EACA,kCAAA;EACA,UAAA;AA6FJ;AA1FE;EACE,kBAAA;EACA,oBAAA;AA4FJ;AA1FI;EACE,UAAA;AA4FN;AAzFI;EACE,UAAA;AA2FN;;AAtFA;EACE,cDnGc;ECoGd,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,iBAAA;EACA,yBAAA;EACA,8BAAA;EACA,oBAAA;EACA,2DACE;EAGF,eAAA;EACA,UAAA;AAsFF;AApFE;EAEE,YAAA;EACA,oBAAA;AAqFJ;AAlFE;EACE,sBD9HY;ACkNhB;AAjFE;EACE;IACE,sBDnIU;ECsNd;AACF;AAhFE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;EACA,yBAAA;EACA,UAAA;EACA,oBAAA;AAkFJ;AA/EE;EACE,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,6BAAA;EACA,UAAA;EACA,yBAAA;EACA,kCAAA;EACA,UAAA;EACA,oBAAA;AAiFJ;AA9EE;EACE,kBAAA;EACA,oBAAA;AAgFJ;AA9EI;EACE,UAAA;AAgFN;AA7EI;EACE,UAAA;AA+EN;;AA1EA;;EAGE,kBAAA;EACA,SAAA;EACA,gCAAA;EACA,gBAAA;EACA,UAAA;EACA,8BAAA;AA4EF;AA1EE;;EAEE,YAAA;AA4EJ;AAzEE;;EACE,qBD/LU;AC2Qd","sourcesContent":["// Fonts\n$font-primary: 'Jost', sans-serif;\n$font-secondary: 'Jost', sans-serif;\n\n// Colors\n$color-primary: #0f0f0f;\n$color-secondary: #ffffff;\n$light-gray: #f0f0f0;\n$gray: #bdbdbd;\n$medium-gray: #8c8c8c;\n$dark-gray: #545454;\n$color-alert: #ed4848;\n\n// Placeholders\n%body-s {\n  font-family: $font-secondary;\n  font-size: 12px;\n  line-height: 18px;\n  letter-spacing: 0.04em;\n}\n\n%body-m {\n  font-family: $font-secondary;\n  font-size: 14px;\n  line-height: 24px;\n  letter-spacing: 0.01em;\n}\n\n%body-l {\n  font-family: $font-secondary;\n  font-size: 18px;\n  line-height: 26px;\n  letter-spacing: 0.01em;\n}\n\n// Animations\n$speed-smooth: 1s;\n$speed-slow: 0.65s;\n$speed-medium: 0.35s;\n$speed-fast: 0.25s;\n$speed-very-fast: 0.15s;\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n","@import './common.scss';\n@import './clear.scss';\n\n@font-face {\n  font-family: 'Jost';\n  src:\n    url('../public/fonts/Jost-Regular.woff2') format('woff2'),\n    url('../public/fonts/Jost-Regular.woff') format('woff');\n  font-weight: 400;\n}\n\nbody {\n  font-family: $font-secondary;\n  color: $color-primary;\n  margin: 0;\n\n  * {\n    box-sizing: border-box;\n  }\n}\n\n.btn-primary {\n  color: $color-secondary;\n  text-align: center;\n  position: relative;\n  width: 100%;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: $color-primary;\n  padding: 8px 16px;\n  border: 0;\n  outline: 0;\n  transition:\n    color $speed-fast,\n    background-color $speed-medium,\n    opacity $speed-medium;\n  cursor: pointer;\n  z-index: 0;\n  text-transform: uppercase;\n\n  &:disabled,\n  &[disabled] {\n    opacity: 0.7;\n    pointer-events: none;\n  }\n\n  &:focus-visible {\n    background-color: $dark-gray;\n  }\n\n  @media (hover: hover) {\n    &:hover {\n      background-color: $dark-gray;\n    }\n  }\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: block;\n    background-color: rgba($color: $color-secondary, $alpha: 0.6);\n    opacity: 0;\n    transition: opacity $speed-fast;\n    z-index: 1;\n  }\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: calc(50% - 10px);\n    left: calc(50% - 10px);\n    width: 16px;\n    height: 16px;\n    display: block;\n    border-radius: 50%;\n    border: 4px solid $color-primary;\n    border-top: 4px solid $dark-gray;\n    opacity: 0;\n    transition: opacity $speed-fast;\n    animation: spin 2s linear infinite;\n    z-index: 2;\n  }\n\n  &.loading {\n    color: transparent;\n    pointer-events: none;\n\n    &::before {\n      opacity: 1;\n    }\n\n    &::after {\n      opacity: 1;\n    }\n  }\n}\n\n.btn-outline {\n  color: $color-primary;\n  text-align: center;\n  position: relative;\n  width: 100%;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: transparent;\n  padding: 8px 16px;\n  border: 1px solid $color-primary;\n  outline: 1px solid transparent;\n  outline-offset: -2px;\n  transition:\n    color $speed-fast,\n    outline-color $speed-medium,\n    opacity $speed-medium;\n  cursor: pointer;\n  z-index: 0;\n\n  &:disabled,\n  &[disabled] {\n    opacity: 0.7;\n    pointer-events: none;\n  }\n\n  &:focus-visible {\n    outline-color: $color-primary;\n  }\n\n  @media (hover: hover) {\n    &:hover {\n      outline-color: $color-primary;\n    }\n  }\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: block;\n    opacity: 0;\n    transition: opacity $speed-fast;\n    z-index: 1;\n    pointer-events: none;\n  }\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: calc(50% - 10px);\n    left: calc(50% - 10px);\n    width: 16px;\n    height: 16px;\n    display: block;\n    border-radius: 50%;\n    border: 4px solid $color-primary;\n    border-top: 4px solid $dark-gray;\n    opacity: 0;\n    transition: opacity $speed-fast;\n    animation: spin 2s linear infinite;\n    z-index: 2;\n    pointer-events: none;\n  }\n\n  &.loading {\n    color: transparent;\n    pointer-events: none;\n\n    &::before {\n      opacity: 1;\n    }\n\n    &::after {\n      opacity: 1;\n    }\n  }\n}\n\ninput[type='text'],\nselect {\n  @extend %body-m;\n  padding: 2px 0 8px;\n  border: 0;\n  border-bottom: 1px solid $color-primary;\n  border-radius: 0;\n  outline: 0;\n  transition: border-color $speed-medium;\n\n  &::placeholder {\n    @extend %body-m;\n    opacity: 0.5;\n  }\n\n  &.error {\n    border-color: $color-alert;\n  }\n}\n","html,\nbody,\ndiv,\nspan,\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd,\narticle,\naside,\ncanvas,\ndetails,\nembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\noutput,\nruby,\nsection,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font: inherit;\n  vertical-align: baseline;\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
